import { axiosInstance } from '.'
import { GET_FAQS_V1 } from './endpoints'

export type FaqItemPublic = {
  id: number
  question: string
  answer: string
  sort_order: number
}

export type FaqCategoryGroup = {
  category: string | null
  items: FaqItemPublic[]
}

export type FaqListResponse = {
  categories: FaqCategoryGroup[]
}

export const faqServices = {
  getFaqs: async (): Promise<FaqListResponse> => {
    const { data } = await axiosInstance.get<FaqListResponse>(GET_FAQS_V1)
    return data
  },
}
